module.exports = {
  email: 'michaelndoh9@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/micheal-ndoh',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/micheal-ndoh/',
    },
    {
      name: 'Discord',
      url: 'https://discord.com/users/1128041830760587446',
    },
    {
      name: 'Credly',
      url: 'https://www.credly.com/users/michael-ndoh.eeacc7e9',
    },
    {
      name: 'Slack',
      url: 'mailto:Michael.Ndoh@adorsys.com',
    },
    {
      name: 'Outlook',
      url: 'mailto:Michael.Ndoh@adorsys.com',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Education',
      url: '/#education',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Certificates',
      url: '/#certificates',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => {
    // Use a more aggressive viewFactor for mobile devices
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    const mobileViewFactor = isMobile ? 0.1 : viewFactor;
    const mobileDelay = isMobile ? delay * 0.5 : delay;
    
    return {
      origin: 'bottom',
      distance: '20px',
      duration: 500,
      delay: mobileDelay,
      rotate: { x: 0, y: 0, z: 0 },
      opacity: 0,
      scale: 1,
      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      mobile: true,
      reset: false,
      useDelay: 'always',
      viewFactor: mobileViewFactor,
      viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    };
  },
};
